<template>
  <section class="info">
    <div class="container container_sec" :class="dayNight">
      <h1 class="info__title">{{ msg.note }}</h1>
      <p>
        Для возврата на главную страницу жмите на "домик", для выбора даты - на
        значок календаря, возврата в текущий день - на круговую стрелку, язык
        переключается через "тумблер", переключение темы - по клику на дату.
        Даты отображаются по новому стилю в диапазоне [14.01.2025 - 13.01.2026].
      </p>
      <p>
        Данное приложение разработано для тех, кто имеет доброе намерение
        почитать Евангелие дня и Апостольское чтение на текущий день. Для этого
        есть возможность открыть как русский (в Синодальном переводе), так и
        церковнославянский варианты текстов. В последнем случае клик по стиху
        приводит к появлению всплывающей подсказки, содержащей стих в
        синодальном переводе. Приложение носит образовательный характер, и может
        быть установлено на устройство из браузера для просмотра в offline.
      </p>
      <p>
        В Богослужебной практике схема распределения чтений на текущий день
        имеет в основе творческий системный подход. Издревле, ранее, чем было
        разработано деление книг Нового Завета на главы, принято его чтение по
        зачалам. Практика деления на зачала зародилась в V веке (Настольная
        книга священнослужителя, Т. 1., С. 50). Согласно древней традиции,
        зачала на каждый день подобраны так, что их смысл соотносится с
        переживаемым событием. Каждое зачало можно рассматривать как отрывок,
        начинающийся с вводного стиха. Например, «Во время оно…», «Братие…»,
        «Чадо Тимофее, …». Наличие вводного и логическая завершенность конечного
        стиха придает зачалу самостоятельность вступления, логичность
        повествования и полноту. Синодальный перевод не содержит вводных стихов
        и зачал.
      </p>
      <p>
        В приложении использована календарная основа с официального сайта rop.ru
        Издательства Московской Патриархии Русской Православной Церкви. Права на
        календарную основу (месяцеслов) принадлежат Издательству Московской
        Патриархии Русской Православной Церкви. Издательство Московской
        Патриархии Русской Православной Церкви не несет ответственности за
        содержание разметки церковных служб разработчиков, использующих
        официальную календарную основу (месяцеслов) на 2024 год. В схеме чтений
        на текущий день используются сокращенные наименования книг Нового
        Завета. Сокращения размещены в отдельном разделе.
      </p>
      <p>
        Чтение на текущий день церковного календаря имеет свои особенности,
        первая из которых заключается в том, что в большинстве случаев день
        начинается с вечерней службы накауне. Поэтому, если на календаре,
        например, 15-е число и имеется указание на чтения на Утрени и Литургии,
        то Утреня – вечернее время 14-го числа, а Литургия – непосредственный
        день.
      </p>
      <p>
        Другая особенность заключается в том, что сначала читаются Апостольские
        зачала, а затем – Евангельские.
      </p>
      <p>
        Система хранения набора данных в приложении, а также алгоритмы их
        обработки имеют государственную регистрацию в
        <a href="https://fips.ru" target="blank"
          >ФЕДЕРАЛЬНОМ ИНСТИТУТЕ ПРОМЫШЛЕННОЙ СОБСТВЕННОСТИ.</a
        >
      </p>
      <p>
        В случае необходимости, вы можете обратиться на
        <a href="mailto:istuunir@gmail.com">электронный адрес</a>
        разработчиков.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TheInfo',
  props: {
    msg: Object
  },
  computed: {
    dayNight() {
      return {
        fonday: this.msg.isDay,
        txtDay: this.msg.isDay,
        fonnight: !this.msg.isDay,
        txtNight: !this.msg.isDay
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.info {
  display: flex;
  &__title {
    text-align: center;
  }
  p {
    font-size: 1.5rem;
    line-height: 1.9rem;
  }
}
</style>
